import React, { FC, useContext, useEffect } from "react";
import { CloseButton, Modal } from "react-bootstrap";
import CardContext from "../../utils/store/card-context";

interface GenericModalSchema {
  modalState: boolean;
  handler: () => void;
  children: React.ReactNode; // modal body
  showFooter: boolean;
  footerNode?: React.ReactNode;
  height?: string;
  width?: string;
  noCloseButton?: boolean;
  backDrop?: boolean;
  backButton?: string;
}

const ProductDetailsModal: FC<GenericModalSchema> = ({
  modalState,
  handler,
  showFooter,
  footerNode,
  children,
  width,
  height,
  noCloseButton,
  backButton,
}) => {
  const icons = useContext(CardContext);

  useEffect(() => {
    const elem4: any = document.querySelector(".linetable-product-modal .footer-main");
    if (elem4) {
      elem4.style.zIndex = "10";
    }
    const elem: any =
      document && document.querySelector(".modal-dialog.linetable-product-modal");
    if (elem) {
      elem.style.maxWidth = width;
      elem.style.padding = "0";
      elem.style.transform = "none";
    }
    const elem1: any = document.querySelector(".linetable-product-modal .modal-content");
    if (elem1) {
      elem1.style.height = height;
      elem1.style.backgroundColor = "#F7F6F5";
    }
    const elem2: any = document.querySelector(".linetable-product-modal .modal-header");
    if (elem2) {
      elem2.style.position = "absolute";
      elem2.style.top = "0";
      elem2.style.zIndex = "1";
      elem2.style.maxWidth = "100%";
      elem2.style.background = "#f8f8f8";
      elem2.style.width = "100%";
    }
    const elem3: any = document.querySelector(".linetable-product-modal .modal-body");
    if (elem3) {
      elem3.style.background = "#f8f8f8";
      elem3.style.paddingTop = "70px";
    }
  }, [height]);

  return (
    <Modal
      scrollable={false}
      show={modalState}
      onHide={handler}
      keyboard={false}
      dialogClassName="linetable-product-modal"
    >
      <Modal.Header>
        {backButton && (
          <div
            style={{ justifyContent: "start", cursor: "pointer" }}
            onClick={handler}
          >
            <>
              {icons?.arrowLeftRed && (
                <img src={icons?.arrowLeftRed} width={24} height={24} alt='arrowLeft'></img>
              )}
              <span style={{ color: "#DA291C" }}>&nbsp;{backButton}</span>
            </>
          </div>
        )}
        <div
          style={{
            display: noCloseButton ? "none" : "",
            justifyContent: "end",
          }}
        >
          <CloseButton className="sr-modal-close" onClick={handler} />
        </div>
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>

      {showFooter && <Modal.Footer>{footerNode}</Modal.Footer>}
    </Modal>
  );
};

export default ProductDetailsModal;
